import { Button } from "@mui/material";
import { MondooYellowLogoIcon } from "~/icons";

type UnlockFlagLinkProps = {
  url: string;
};

const UnlockFlagLink = ({ url }: UnlockFlagLinkProps) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: "flex", flexShrink: 0, textDecoration: "none" }}
    >
      <Button
        variant="text"
        sx={{
          height: 25,
        }}
      >
        <MondooYellowLogoIcon />
      </Button>
    </a>
  );
};

export default UnlockFlagLink;
